import { Component, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { Router } from "@angular/router";

import { LoginService } from 'nm-socle-application/app/components/login/login.service';
import { GeoServices } from 'nm-socle-application/app/services/geo.service';
import { ConfigService } from 'nm-socle-application/app/services/config.service';
import { TemplateInitService } from 'nm-socle-application/app/shared/services/template-init.service';
import {LoginFormComponent} from 'nm-socle-application/app/components/login/login-form/login-form.component';
import {TranslateService} from 'ng2-translate';

@Component({
    selector: 'login-reconnect',
    templateUrl: './login-reconnect.component.html',
    styleUrls: ['./login-reconnect.component.scss'],
    changeDetection:ChangeDetectionStrategy.OnPush,
})
export class LoginReconnectComponent extends LoginFormComponent {

    constructor(
        public loginService: LoginService,
        public geoServices: GeoServices,
        protected _configService: ConfigService,
        protected _router: Router,
        protected _translateService: TranslateService,
        protected _cd:ChangeDetectorRef,
        protected _templateInitService: TemplateInitService,
    ) {
        super(loginService, geoServices, _configService, _router, _translateService, _cd, _templateInitService)
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/components/login/login-reconnect/login-reconnect.component.ts